import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Button, Grid, TextField, Stepper, Step, StepLabel, Typography, CircularProgress, Box } from '@mui/material';
import Alert from '@mui/material/Alert';
import { PatternFormat } from 'react-number-format';
// project imports
import axios from 'src/utils/axios';
import SendIcon from '@mui/icons-material/Send';
import InputAdornment from '@mui/material/InputAdornment';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import SystemSecurityUpdateGoodIcon from '@mui/icons-material/SystemSecurityUpdateGood';
import { getUser } from 'src/utils/Common';

const KocAilem = ({ EmployeeNr, setWarning, setWarningType, setresponseMessage, CellPhone, setKocAilemPopUp }) => {
    const theme = useTheme();
    const steps = ["KoçAilem KVKK İşlemi", "KoçAilem Onay İşlemi"];
    const [activeStep, setActiveStep] = React.useState(0);
    const [onayKodu, setOnayKodu] = useState('');
    const [telephoneNumber, setTelephoneNumber] = useState(CellPhone);
    const [responseMessage, setResponseMessage] = useState("");
    const [responseType, setResponseType] = useState("error");
    const SessionUser = getUser();
    const [loading, setLoading] = useState(false);
    const [completed, setCompleted] = React.useState(false);


    const handleSendCode = () => {
        setLoading(true);
        axios.get(`KocAilemKodGonder/${EmployeeNr}/${telephoneNumber}`).then((response) => {
            if (response.data.ErrorCode == 0) {
                setResponseMessage(response.data.ErrorDescription);
                setResponseType("success");
                setActiveStep(1);
                setLoading(false);
            } else {
                setResponseMessage(response.data.ErrorDescription);
                setResponseType("error");
                setLoading(false);
            }

        }).catch((error) => {
            setResponseMessage("Bir hata oluştu. Lütfen tekrar deneyiniz.");
            setResponseType("error");
            setLoading(false);
        });


    };

    const handleSaveConfirm = () => {
        setLoading(true);
        axios.get(`KocAilemliYap/${EmployeeNr}/${onayKodu}/${SessionUser.SessionTokenWs}`).then((response) => {
            if (response.data.ErrorCode == 0) {
                setCompleted(true);
                setResponseMessage(response.data.ErrorDescription);
                setResponseType("success");
                //setKocAilemPopUp(false);
                setLoading(false);
            } else {
                setResponseMessage(response.data.ErrorDescription);
                setResponseType("error");
                setLoading(false);
            }
        }).catch((error) => {
            setResponseMessage("Bir hata oluştu. Lütfen tekrar deneyiniz.");
            setResponseType("error");
            setLoading(false);
        });
    };



    return (
        <>
            <Grid container justifyContent="center" spacing={5}>
                <Grid size={12}>
                    <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                            <Step sx={{
                                '& .MuiStepLabel-root .Mui-completed': {
                                    color: 'grey.500', // circle color (COMPLETED)
                                },
                                '& .MuiStepLabel-root .Mui-active': {
                                    color: '#FF9800', // circle color (ACTIVE)
                                },
                            }}
                                key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Grid>
                {loading ?
                    <Grid
                        size={{
                            xs: 12,
                            sm: 12,
                            md: 12
                        }}>
                        <Box display="flex" justifyContent="center" alignItems="center" >
                            <CircularProgress color="inherit" />
                            <Typography
                                position='absolute'
                                style={{
                                    color: '#FF9800',
                                    marginLeft: '10px',
                                    fontWeight: 'bold',
                                    fontSize: '20px'
                                }}>
                                Lütfen bekleyiniz...
                            </Typography>
                        </Box>
                    </Grid> :
                    <Grid
                        size={{
                            xs: 12,
                            sm: 12,
                            md: 12
                        }}>
                        {activeStep === 0 && (
                            <>
                                <Grid container spacing={3}>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            sm: 12,
                                            md: 8
                                        }}>
                                        <PatternFormat
                                            id='description'
                                            format="(###) ###-####"
                                            variant='outlined'
                                            fullWidth
                                            value={telephoneNumber}
                                            onChange={(event) => {
                                                setTelephoneNumber(event.target.value);
                                            }}
                                            customInput={TextField}
                                            label="Cep Telefonu"
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <PhoneIphoneIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            sm: 12,
                                            md: 4
                                        }}>
                                        <Button
                                            style={{ maxHeight: '52px', minHeight: '52px' }}
                                            variant="contained"
                                            color="secondary"
                                            endIcon={<SendIcon></SendIcon>}
                                            onClick={handleSendCode}
                                        >
                                            Kod Gönder
                                        </Button>
                                    </Grid>
                                    {responseMessage?.length > 0 ?
                                        <Grid
                                            size={{
                                                xs: 12,
                                                sm: 12,
                                                md: 12
                                            }}>
                                            <Alert severity={responseType} style={{ fontSize: '15px' }}>
                                                {responseMessage}
                                            </Alert>
                                        </Grid>
                                        : null}
                                </Grid>
                            </>
                        )}
                        {activeStep === 1 && (
                            <>
                                <Grid container spacing={3}>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            sm: 12,
                                            md: 12
                                        }}>
                                        <Typography variant="h6" gutterBottom>
                                            {"Kişisel verilerimin KoçAilem ayrıcalıklarından faydalanmam için işlenmesine ve KoçAilem'e aktarılmasına onay veriyorum."}
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            sm: 12,
                                            md: 8
                                        }}>
                                        <TextField
                                            label={'Onay Kodu'}
                                            id='description'
                                            variant='outlined'
                                            fullWidth
                                            value={onayKodu}
                                            onChange={(event) => {
                                                setOnayKodu(event.target.value);
                                            }}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SystemSecurityUpdateGoodIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </Grid>
                                    <Grid
                                        size={{
                                            xs: 12,
                                            sm: 12,
                                            md: 4
                                        }}>
                                        <Button
                                            style={{ maxHeight: '52px', minHeight: '52px' }}
                                            variant="contained"
                                            color="secondary"
                                            endIcon={<SendIcon></SendIcon>}
                                            onClick={handleSaveConfirm}
                                            disabled={completed}
                                        >
                                            Onaylıyorum
                                        </Button>
                                    </Grid>
                                    {responseMessage?.length > 0 ?
                                        <Grid
                                            size={{
                                                xs: 12,
                                                sm: 12,
                                                md: 12
                                            }}>
                                            <Alert severity={responseType} style={{ fontSize: '15px' }}>
                                                {responseMessage}
                                            </Alert>
                                        </Grid>
                                        : null}
                                </Grid>
                            </>
                        )}
                    </Grid>
                }
            </Grid>
        </>
    );
};


export default KocAilem;
